'use client';

import { MathJaxContext } from 'better-react-mathjax';
import { PropsWithChildren } from 'react';

const config = {
  loader: { load: ['input/asciimath', 'output/svg'] },
  tex: {
    packages: { '[+]': ['base', 'ams', 'boldsymbol'] },
    inlineMath: [
      ['$', '$'],
      ['\\(', '\\)'],
    ],
    displayMath: [
      ['$$', '$$'],
      ['\\[', '\\]'],
    ],
  },
  svg: {
    fontCache: 'global',
  },
};

export function MathJaxProvider({ children }: PropsWithChildren) {
  return (
    <MathJaxContext version={3} config={config} src='https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js'>
      {children}
    </MathJaxContext>
  );
}
